/**
 * BlockTokenChip — compact chip where the whole control is “tap to remove”
 * For Media Devoted | Created By Ciro Autiero
 *
 * The live formula canvas uses `canvas/SortableFormulaChip` (grip + ×) for
 * drag-reorder; this component stays available for simple one-action affordances.
 */

import { FC } from 'react';

import type { ChipKind } from './blocks.tokens';

const KIND_STYLES: Record<ChipKind, string> = {
  metric: 'bg-primary/10 text-primary border-primary/30',
  subref: 'bg-success/15 text-success border-success/40',
  number: 'bg-card text-foreground border-border',
  op: 'bg-warning/15 text-foreground border-warning/40',
  fn: 'bg-accent text-accent-foreground border-accent',
  lparen: 'bg-muted text-muted-foreground border-border',
  rparen: 'bg-muted text-muted-foreground border-border',
  comma: 'bg-muted text-muted-foreground border-border',
};

/** Shared surface classes for palette chips and sortable canvas chips. */
export function chipKindClassName(kind: ChipKind): string {
  return KIND_STYLES[kind];
}

export interface BlockTokenChipProps {
  kind: ChipKind;
  display: string;
  onRemove: () => void;
}

const BlockTokenChip: FC<BlockTokenChipProps> = ({ kind, display, onRemove }) => (
  <button
    type="button"
    onClick={onRemove}
    aria-label={`Remove ${display}`}
    title={`Click to remove ${display}`}
    className={`group inline-flex items-center gap-1 rounded-md border px-2 py-1 text-xs font-medium transition-colors hover:border-destructive/60 hover:bg-destructive/10 hover:text-destructive ${chipKindClassName(kind)}`}
  >
    <span>{display}</span>
    <span className="text-[10px] opacity-50 group-hover:opacity-100">×</span>
  </button>
);

export default BlockTokenChip;
